const ENV_DEFAULTS = {
  production: {
    BASEURL: 'https://api.psylaris.nl/api',
    FILE_SERVICE_URL: 'https://file-service-api-prod-dot-turnkey-setup-246812.ew.r.appspot.com',
  },
  local: {
    BASEURL: 'https://api-acc-dot-turnkey-setup-246812.appspot.com/api',
    FILE_SERVICE_URL: 'https://file-service-api-acc-dot-turnkey-setup-246812.ew.r.appspot.com',
  },
  acceptance: {
    BASEURL: 'https://api-acc-dot-turnkey-setup-246812.appspot.com/api',
    FILE_SERVICE_URL: 'https://file-service-api-acc-dot-turnkey-setup-246812.ew.r.appspot.com',
  },
  integration: {
    BASEURL: 'http://integration-api.psylaris.nl/api',
    FILE_SERVICE_URL: 'https://file-service-api-acc-dot-turnkey-setup-246812.ew.r.appspot.com',
  },
};

const detectEnv = (origin: string): keyof typeof ENV_DEFAULTS => {
  if (origin.includes('localhost:') || origin.includes('ngrok-free.app') || origin.includes('127.0.0.1'))
    return 'local';
  if (origin.includes('acc-emdr-remote') || origin.includes('emdr-remote-acceptance')) return 'acceptance';
  if (origin.includes('emdr-remote-integration')) return 'integration';
  return 'production';
};

const defaults = ENV_DEFAULTS[detectEnv(window.location.origin)];

const BASEURL = import.meta.env.VITE_API_BASE_URL || defaults.BASEURL;
export const FILE_SERVICE_URL = import.meta.env.VITE_FILE_SERVICE_URL || defaults.FILE_SERVICE_URL;

export const buildClientPageUrl = (treatmentId: string, sessionId: string): string =>
  `${window.location.origin}/clientpage?treatmentUUID=${treatmentId}&sessionUUID=${sessionId}&deviceId=`;

export const NETWORK_RECONNECT_TIMEOUT_MS = 25_000;
export const NETWORK_RECONNECT_BANNER_LINGER_MS = 4_000;
export const CALL_START_TOKEN_TIMEOUT_MS = 15_000;
export const CALL_CONNECT_TIMEOUT_MS = 15_000;
export const ALERT_TRANSITION_MS = { enter: 320, exit: 260 };
export const WAITING_FOR_CLIENT_TIMEOUT_MS = 30_000;
export const AUTO_RECALL_BEFORE_RESTART_MS = 1500;
export const AUTO_RECALL_MIN_PRESENCE_AFTER_ARM_MS = 2_000;
export const INITIAL_WAITING_POPUP_DELAY_MS = 2_500;
export const CLIENT_ROOM_NOT_FOUND_RETRY_WINDOW_MS = 30_000;

export const CLIENT_PAGE_PRESENCE_URI = 'presence://client-page';
export const PRESENCE_HEARTBEAT_MS = 30_000;
export const CLIENT_PAGE_PRESENCE_TIMEOUT_MS = 90_000;

// The VR headset pushes a DEVICE_STATUS_REPORT every 5s. (The code default on
// DeviceStatusReportCommandSender reads `updateFrequency: 15`, but the Unity scene
// overrides it to 5 — confirmed by Tom H.; visible as "[COMMAND] Queueing command:
// BatteryHeadset" logs every 5s.) Delivery can still stall behind PushCommands' retry
// loop, so keep a wide margin: 120s is ~24 missed reports.
export const DEVICE_HEARTBEAT_TIMEOUT_MS = 120_000;

export const normalizePresenceUri = (uri: string) => uri.replace(/\\/g, '').trim();
export const isClientPagePresenceUri = (uri: string) => normalizePresenceUri(uri).startsWith(CLIENT_PAGE_PRESENCE_URI);

export default BASEURL;
